module.exports = __webpack_public_path__ + "img/Rectangle 147@2x.84fd0642.png";